import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { utcToLocalDate } from "../../../utils/dateConvert";
import { downloadCSVFile } from "../../../api/apiClient";
import { formatTemperatureReading, sanitizeTemperatureReadings, temperatureReadingClass } from "../../../utils/temperature";

function LogTable(props) {
  let assetName = props.assetCustomerName;
  let assetId = props.assetId;
  let timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : '';
  let tempAEnabled = props.tempAEnabled;
  let tempBEnabled = props.tempBEnabled;
  let doorSensorEnabled = props.doorSensorEnabled;
  const data = (
    <Table responsive striped>
      <thead>
        <tr className="nowwrapTH">
          <th>Date</th>
          {tempAEnabled && (<th>Temp A</th>)}
          {tempBEnabled && (<th>Temp B</th>)}

          <th>Fridge</th>
          <th>Ignition</th>
          {doorSensorEnabled && (<th>Door</th>)}
        </tr>
      </thead>
      <tbody>
        {props.logTable.map((exception, index) => {
          return (
            <tr>
              <td>{utcToLocalDate(exception.date)}</td>
              {tempAEnabled && (<td className={temperatureReadingClass(exception.tempA)}>{formatTemperatureReading(exception.tempA)}</td>)}
              {tempBEnabled && (<td className={temperatureReadingClass(exception.tempB)}>{formatTemperatureReading(exception.tempB)}</td>)}
              <td>{exception.fridgeStatus ? "On" : "Off"}</td>
              <td>{exception.ignitionStatus ? "On" : "Off"}</td>
              {doorSensorEnabled && (<td>{exception.doorSensorStatus}</td>)}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );

  const handleDownloadExcel = () => {
    downloadCSVFile(props.logTable.map(sanitizeTemperatureReadings), "Temperature_Logs", assetName, timeZone, assetId);
  };

  return (
    <ToggleBar
      caption="Logs"
      icon="fa fa-table"
      color="#A94442"
      content={data}
      download={handleDownloadExcel}
    />
  );
}

export default LogTable;
